import { useState, useEffect, useCallback } from "react";
import { verifyToken, clearToken, fetchTransactions } from "./api";
import LoginScreen from "./components/LoginScreen";
import MerchantSelectScreen from "./components/MerchantSelectScreen";
import Dashboard from "./components/Dashboard";

export default function App() {
  const [authed, setAuthed] = useState(false);
  const [authChecking, setAuthChecking] = useState(true);
  const [transactions, setTransactions] = useState(null);
  const [accounts, setAccounts] = useState([]);
  const [merchantName, setMerchantName] = useState("");
  const [settings, setSettings] = useState({});
  const [loading, setLoading] = useState(false);
  const [statusMsg, setStatusMsg] = useState("");
  const [currentMerchantId, setCurrentMerchantId] = useState(null);
  const [currentDays, setCurrentDays] = useState(120);

  useEffect(() => {
    verifyToken()
      .then((valid) => { if (valid) setAuthed(true); })
      .finally(() => setAuthChecking(false));
  }, []);

  const handleLogout = useCallback(() => {
    clearToken();
    setAuthed(false);
    setTransactions(null);
    setAccounts([]);
    setMerchantName("");
    setSettings({});
    setCurrentMerchantId(null);
  }, []);

  const loadMerchant = useCallback(async (merchantId, days = 120) => {
    setLoading(true);
    setStatusMsg("Fetching transactions...");
    try {
      const data = await fetchTransactions(merchantId, days);
      setTransactions(data.transactions);
      setAccounts(data.accounts || []);
      setMerchantName(data.merchant_name || "");
      setSettings(data.settings || {});
      setCurrentMerchantId(merchantId);
      setCurrentDays(days);
    } catch (err) {
      alert("Error fetching data: " + err.message);
    } finally {
      setLoading(false);
      setStatusMsg("");
    }
  }, []);

  const handleChangeDays = useCallback((days) => {
    if (currentMerchantId) {
      loadMerchant(currentMerchantId, days);
    }
  }, [currentMerchantId, loadMerchant]);

  if (authChecking) {
    return (
      <div style={{ minHeight: "100vh", background: "#080c0e", display: "flex", alignItems: "center", justifyContent: "center" }}>
        <div style={{ color: "#555", fontSize: 12, fontFamily: "'IBM Plex Mono', monospace" }}>Verifying session...</div>
      </div>
    );
  }

  if (!authed) {
    return <LoginScreen onLogin={() => setAuthed(true)} />;
  }

  if (!transactions) {
    return (
      <MerchantSelectScreen
        onSelect={(id) => loadMerchant(id, currentDays)}
        onLogout={handleLogout}
        loading={loading}
        statusMsg={statusMsg}
      />
    );
  }

return (
    <Dashboard
      transactions={transactions}
      accounts={accounts}
      merchantName={merchantName}
      merchantId={currentMerchantId}
      settings={settings}
      currentDays={currentDays}
      onNewAnalysis={() => { setTransactions(null); setCurrentMerchantId(null); }}
      onLogout={handleLogout}
      onChangeDays={handleChangeDays}
      onTransactionsUpdate={setTransactions}
    />
  );
}
